export enum TransactionStatusEnum {
  NEGOTIATE = 0,
  REQUEST = 1,
  ACCEPT = 2,
  REJECT = 3,
  DELIVERED_TO_SHIP = 4,
  RECEIVED = 5,
  INVOICE_ISSUED = 6,
  COMPLETED = 7,
  BUYER_REQUEST_CANCEL = 20,
  SELLER_REQUEST_CANCEL = 21,
  BUYER_ACCEPT_CANCEL = 22,
  SELLER_ACCEPT_CANCEL = 23,
}

export const TransactionStatusLabel: {
  [key in TransactionStatusEnum]: string;
} = {
  [TransactionStatusEnum.NEGOTIATE]: "交渉中",
  [TransactionStatusEnum.REQUEST]: "申請",
  [TransactionStatusEnum.ACCEPT]: "承認",
  [TransactionStatusEnum.REJECT]: "拒否",
  [TransactionStatusEnum.DELIVERED_TO_SHIP]: "発送済み",
  [TransactionStatusEnum.RECEIVED]: "受領済み",
  [TransactionStatusEnum.INVOICE_ISSUED]: "請求書発行済み",
  [TransactionStatusEnum.COMPLETED]: "完了",
  [TransactionStatusEnum.BUYER_REQUEST_CANCEL]: "購入者がキャンセル申請",
  [TransactionStatusEnum.SELLER_REQUEST_CANCEL]: "出品者がキャンセル申請",
  [TransactionStatusEnum.BUYER_ACCEPT_CANCEL]: "購入者がキャンセル承認",
  [TransactionStatusEnum.SELLER_ACCEPT_CANCEL]: "出品者がキャンセル承認",
};

export const TRANSACTION_HISTORY_FILTER_STATUS_TYPE: Record<
  string,
  { value: string; label: string }
> = {
  UNDER_NEGOTIATION: {
    value: TransactionStatusEnum.NEGOTIATE.toString(),
    label: TransactionStatusLabel[TransactionStatusEnum.NEGOTIATE],
  },
  REQUEST: {
    value: TransactionStatusEnum.REQUEST.toString(),
    label: TransactionStatusLabel[TransactionStatusEnum.REQUEST],
  },
  WAIT_SHIP: {
    value: TransactionStatusEnum.DELIVERED_TO_SHIP.toString(),
    label: TransactionStatusLabel[TransactionStatusEnum.DELIVERED_TO_SHIP],
  },
  RECEIPT_COMPLETE: {
    value: TransactionStatusEnum.RECEIVED.toString(),
    label: TransactionStatusLabel[TransactionStatusEnum.RECEIVED],
  },
  TRANSACTION_COMPLETE: {
    value: TransactionStatusEnum.COMPLETED.toString(),
    label: TransactionStatusLabel[TransactionStatusEnum.COMPLETED],
  },
  CANCEL: {
    value: [
      TransactionStatusEnum.SELLER_ACCEPT_CANCEL,
      TransactionStatusEnum.BUYER_ACCEPT_CANCEL,
    ].join(","),
    label: "キャンセル",
  },
};
